import React from 'react';
import styled from 'styled-components';
import { media } from '../../styles/responsive';
import Sidebar from './Sidebar';

const LayoutContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
`;

const MainContent = styled.main`
  flex: 1;
  overflow-y: auto;
  background-color: #ffffff;
  
  ${media.tablet`
    margin-left: 0;
    width: 100%;
  `}
`;

const Layout = ({ children }) => {
  return (
    <LayoutContainer>
      <Sidebar />
      <MainContent>
        {children}
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;
